module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-power-up-drongen-2.3d792ada.jpg";